export default __webpack_public_path__ + "static/media/home-ground@2x.4ee1d842.png";